import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface MultimediaListStyledProps {
  isDisabled?: boolean;
}
export const useStyles = makeStyles<Theme, MultimediaListStyledProps>(
  (theme) => ({
    mediaFallback: {
      color: theme.palette.common.white,
      fontSize: '4rem',
    },
    selectedWrapperCard: ({ isDisabled }) => ({
      borderColor: 'transparent !important',
      position: 'relative',

      '&::before': {
        borderRadius: '4px',
        bottom: 0,
        boxShadow: isDisabled
          ? `inset 0 0 0 1px ${theme.palette.grey[300]}`
          : `inset 0 0 0 2px ${theme.palette.primary.main}`,
        content: '""',
        display: 'block',
        left: 0,
        position: 'absolute',
        pointerEvents: 'none',
        right: 0,
        top: 0,
        zIndex: 1,
      },
    }),
    wrapper: {
      backgroundColor: theme.palette.grey[100],
      flex: '1 auto',
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
      paddingTop: '10px',
      width: '100%',
    },
    shiningCard: {
      boxShadow: 'rgb(244 67 54) 5px 5px 10px -5px',
    },
  }),
);
